(function () {
  function initAnnouncement(root) {
    if (!root || root.dataset.initialized === 'true') return;

    var slides = Array.from(root.querySelectorAll('[data-announcement-slide]'));
    var previousButton = root.querySelector('[data-announcement-previous]');
    var nextButton = root.querySelector('[data-announcement-next]');

    if (slides.length === 0) return;

    root.dataset.initialized = 'true';
    var currentIndex = 0;

    function showSlide(index) {
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });
    }

    showSlide(0);

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-announcement-previous], [data-announcement-next]');

      if (!button || !root.contains(button)) return;

      event.preventDefault();
      showSlide(button.hasAttribute('data-announcement-next') ? currentIndex + 1 : currentIndex - 1);
    });

    if (root.dataset.autoRotate === 'true' && slides.length > 1) {
      window.setInterval(function () {
        showSlide(currentIndex + 1);
      }, Number(root.dataset.speed) || 5000);
    }
  }

  function initAllAnnouncements() {
    document.querySelectorAll('[data-mm-announcement-v2]').forEach(initAnnouncement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAnnouncements);
  } else {
    initAllAnnouncements();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches && event.target.matches('[data-mm-announcement-v2]')
      ? event.target
      : event.target.querySelector('[data-mm-announcement-v2]');
    initAnnouncement(root);
  });
})();